import { useSEO } from "../hooks/useSEO";

export default function Terms() {
  useSEO({
    title: "Terms of Service - Qicino Limited | Legal Agreement",
    description: "Read the Terms of Service for Qicino Limited. Our legal agreement governing the use of our website and services.",
    keywords: "terms of service, legal, agreement, terms and conditions, website terms",
    url: "https://qicino.com/terms",
  });

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8">
            Terms of Service
          </h1>

          <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using this website and services, you accept and agree to be
                bound by the terms and provision of this agreement. If you do not agree to
                abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                2. Use License
              </h2>
              <p>
                Permission is granted to temporarily download one copy of the materials
                (information or software) on Qicino Limited's website for personal,
                non-commercial transitory viewing only. This is the grant of a license, not
                a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                3. Disclaimer
              </h2>
              <p>
                The materials on Qicino Limited's website are provided on an 'as is' basis.
                Qicino Limited makes no warranties, expressed or implied, and hereby disclaims
                and negates all other warranties including, without limitation, implied warranties
                or conditions of merchantability, fitness for a particular purpose, or
                non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                4. Limitations
              </h2>
              <p>
                In no event shall Qicino Limited or its suppliers be liable for any damages
                (including, without limitation, damages for loss of data or profit, or due to
                business interruption) arising out of the use or inability to use the materials
                on Qicino Limited's website, even if Qicino Limited or an authorized representative
                has been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                5. Accuracy of Materials
              </h2>
              <p>
                The materials appearing on Qicino Limited's website could include technical,
                typographical, or photographic errors. Qicino Limited does not warrant that any
                of the materials on its website are accurate, complete, or current. Qicino Limited
                may make changes to the materials contained on its website at any time without notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                6. Links
              </h2>
              <p>
                Qicino Limited has not reviewed all of the sites linked to its website and is not
                responsible for the contents of any such linked site. The inclusion of any link
                does not imply endorsement by Qicino Limited of the site. Use of any such linked
                website is at the user's own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                7. Modifications
              </h2>
              <p>
                Qicino Limited may revise these terms of service for its website at any time
                without notice. By using this website, you are agreeing to be bound by the then
                current version of these terms of service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                8. Governing Law
              </h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the
                laws of Nigeria, and you irrevocably submit to the exclusive jurisdiction of the
                courts in that location.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                9. Contact Information
              </h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@qicino.com" className="text-primary hover:underline">
                  info@qicino.com
                </a>
                <br />
                <strong>Address:</strong> Lagos, Nigeria
              </p>
            </section>

            <div className="border-t border-border pt-6 mt-8">
              <p className="text-sm text-muted-foreground">
                Last updated: March 2026. These Terms of Service are subject to change at any time
                without notice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
